module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer original"
  }, [_c('div', {
    attrs: {
      "id": "footer-logo"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/khachapuridze",
      "target": "_blank",
      "rel": "noreferrer"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "version"
    }
  }, [_vm._v("\n                  Vue\n              ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer-credit"
    }
  }, [_vm._v("\n    khachapuridze inc. "), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61d9d280!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterBar.vue
// module id = 460
// module chunks = 2